import { useEffect } from 'react';
import { trackPagesRouter } from "@socialgouv/matomo-next";

const Matomo = () => {
    const MATOMO_URL = "https://matomo.simplify-data.de/";
    const MATOMO_SITE_ID = 1;

    useEffect(() => {
        if (MATOMO_URL && MATOMO_SITE_ID) {
            trackPagesRouter({
                url: MATOMO_URL,
                siteId: MATOMO_SITE_ID,
                disableCookies: true,

            });
        }
    }, []);
};

export default Matomo;
